import React from 'react';

const BicycleGanIcon = () => {
  return (
    <svg width="50" height="50" viewBox="0 0 79.61 79.61">
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="5.34"
          y1="19.91"
          x2="74.27"
          y2="59.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#024284" />
          <stop offset="0.81" stopColor="#004587" />
          <stop offset="0.82" stopColor="#68a93e" />
        </linearGradient>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <circle
            cx="39.8"
            cy="39.8"
            r="38.56"
            style={{
              fill: 'none',
              strokeMiterlimit: '10',
              strokeWidth: '2.48162492794007px',
              stroke: 'url(#linear-gradient)',
            }}
          />
          <circle
            cx="24.27"
            cy="45.87"
            r="9.2"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeMiterlimit: '10',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <circle
            cx="55.34"
            cy="45.87"
            r="9.2"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeMiterlimit: '10',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <polyline
            points="55.34 45.87 50.08 24.54 45.43 24.54"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeMiterlimit: '10',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <polyline
            points="33.29 29.19 37.47 45.87 23.23 45.87 34.37 32.85 51.58 32.85 37.45 45.82"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeMiterlimit: '10',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <line
            x1="29.63"
            y1="28.44"
            x2="36.61"
            y2="28.44"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeMiterlimit: '10',
              strokeWidth: '2.28858660421371px',
            }}
          />
        </g>
      </g>
    </svg>
  );
};

export default BicycleGanIcon;
